import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Input,
  Form,
  GridRow,
  GridColumn,
  Dropdown,
} from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

import SaveChanges from "components/ui/Buttons/SaveButton";

import { updatingSubscriptionType } from "actions/accounts";

import _ from "lodash";
import cx from "classnames";
import styles from "./subscriptionPlan.module.scss";

const initMetrics = {
  licenceCount: 0,
};

const SubscriptionPlan = () => {
  const dispatch = useDispatch();

  const licenseValidationError = useSelector((state) =>_.get(state, "accounts.licenceCount.error", ""));
  const starterLicenceValidationError = useSelector((state) =>_.get(state, "accounts.licenceCount.starterLicenceError" , ""));
  const noOfLicence = useSelector((state) =>_.get(state, "accounts.licenceCount.count", 0));
  const noOfStarterLicence = useSelector((state) =>_.get(state, "accounts.licenceCount.starterLicence", 0));
  const subscriptionPlan = useSelector((state) => _.get(state, "accounts.subscriptionPlan", ""));
  const account = useSelector((state) => state.accounts.account);
  const planId = useSelector((state) =>_.get(state, "accounts.subscriptionPlan.id"));
  const subscriptionType = useSelector((state) =>_.get(state, "accounts.subscriptionPlan", null));

  var plan = _.get(subscriptionPlan, "plan", null);
  var items = _.get(subscriptionPlan, "items", null);

  var isStarter = _.get(subscriptionPlan, "key", "") === 'starter';

  const [metrics, setMetrics] = useState(initMetrics);
  const [disableSave, setDisableSave] = useState(true);
  const [noOfLicenceCount, setnoOfLicenceCount] = useState("");
  const [noOfStarterLicenceCount, setNoOfStarterLicenceCount] = useState(0);
  const [planOptions, setPlanOptions] = useState([]);
  const [initialsubscriptionType, setInitialSubscriptionType] = useState(plan);
  const [selectedSubscriptionPlan, setSelectedSubscriptionPlan] = useState("");
  const [selectedPlanId, setSelectedPlanId] = useState(planId);
  const [selectedPlanKey, setSelectedPlanKey] = useState("");
  const [initialRender, setInitialRender] = useState(true);
  const [starterAccount, setStarterAccount] = useState(isStarter);
  const [subscriptionError, setSubscriptionError] = useState("");
  const [starterError, setStarterError] = useState("");

  useEffect(() => {
    setMetrics({ ...initMetrics });
    // setInitialRender(false);
  }, []);

  useEffect(() => {
    onSetPlanOptions();
  }, [items, initialsubscriptionType]);

  useEffect(() => {
    setInitialSubscriptionType(plan);
  }, [plan]);

  useEffect(() => {
    setStarterAccount(isStarter)
  }, [isStarter]);

  useEffect(() => {
    setnoOfLicenceCount(noOfLicence);
  }, [noOfLicence]);

  useEffect(() => {
    setNoOfStarterLicenceCount(noOfStarterLicence);
  }, [noOfStarterLicence]);

  useEffect(() => {
    setSelectedPlanId(planId);
  }, [planId]);

  useEffect(() => {
    setSubscriptionError(licenseValidationError)
  },[licenseValidationError])

  useEffect(() => {
    if (starterLicenceValidationError) {
      setStarterError(starterLicenceValidationError)
    }
    
  }), [starterLicenceValidationError]

  useEffect(() => {
    if (!initialRender) {
      if (!_.get(subscriptionType, "updating") && _.get(subscriptionType, "error")) {
        toast.error("Failed to update subscription");
      } else if (!_.get(subscriptionType, "updating") && _.get(subscriptionType, "updated")
      ) {
        toast.success("Successfully updated subscription");
      }
    }
    else {
      setInitialRender(false);
    }
  }, [subscriptionType]);

  const handleSavePlanClick = () => {

    if (validateSubscriptionPlan()) {

      dispatch(
        updatingSubscriptionType({
          accountId: account.id,
          subscriptionPlan: selectedPlanId,
          licenceCount: noOfLicenceCount,
          starterLicence: noOfStarterLicenceCount
        })
      );
    }
  };

  const validateSubscriptionPlan = () => {

    if (noOfLicenceCount === "") {
      setSubscriptionError("Licence value is required");
      return false;
    }

    if (noOfStarterLicenceCount === "") {
      setStarterError("Starter Licence value is required");
      return false;
    }
    if (selectedPlanKey && (selectedPlanKey === 'advanced' || selectedPlanKey === 'enterprise') && noOfLicenceCount < 10) {
      setSubscriptionError("Advanced and Enterprise plan should have minimum licence of 10");
      return false;
    } 
    
    setSubscriptionError("");
    setStarterError("");
    setSelectedPlanKey("");
    

    return true;
  };


  const handleLicenceCountUpdate = (e) => {
   
    const licenceCount = e.target.value;
    
    setnoOfLicenceCount(licenceCount);

    if (_.isEmpty(licenceCount)) {
      setDisableSave(true);
    } else {
      setDisableSave(false);
    }
  };

  const handleStarterLicenceUpdate = (e) => {
    const starterLicenceCount = e.target.value;
    
    setNoOfStarterLicenceCount(starterLicenceCount);

    if (_.isEmpty(starterLicenceCount)) {
      setDisableSave(true);
    } else {
      setDisableSave(false);
    }
  };

  const handlePlanUpdate = (e, { value }) => {

    setSelectedSubscriptionPlan(value);
    setSelectedPlanId(value);

    const initialsubscriptionType = value;
    setInitialSubscriptionType(value);

    setStarterAccount(isStarterAccount(value))

    const selectedPlan = _.find(items, { name: value });
    
    if (selectedPlan) {
      setSelectedPlanId(selectedPlan.id);
      setSelectedPlanKey(selectedPlan.key);
    }

    if (_.isEmpty(initialsubscriptionType) || noOfLicenceCount === "" || noOfStarterLicenceCount === "") {
      setDisableSave(true);
    } else {
      setDisableSave(false);
    }
  };

  const onSetPlanOptions = () => {
    let options = _.map(items, (plan) => {
      return { key: plan.name, text: plan.name, value: plan.name };
    });
    setPlanOptions(options);
  };

  const isStarterAccount = (plan) => {
    if (plan) {
      return plan === 'Starter';
    } 
    
  }

  return (
    <Container className={styles.container}>
      <div className={cx(styles.title)}>Subscription Plan</div>
      <br />

        <Grid.Column>
          <div className={styles.labelStyle}> Licence </div>
          <div>
            <Input
              type="number"
              className={cx(styles.inputContainer)}
              value={noOfLicenceCount}
              onChange={handleLicenceCountUpdate}
            />
          </div>

          {subscriptionError && (
            <div className={styles.error}>{subscriptionError}</div>
          )}
          <br />

        {!starterAccount && (
          <>
            <div className={styles.labelStyle}>Starter Licence</div>
            <div>
              <Input
                type="number"
                className={cx(styles.inputContainer)}
                value={noOfStarterLicenceCount}
                onChange={handleStarterLicenceUpdate}
              />
            </div>
          </>
        )}
          {starterError && (
            <div className={styles.error}>{starterError}</div>
          )}

          <br />

          <GridRow columns={2}>
            <GridColumn>
              <Form.Field>
                <div>
                  <label className={cx(styles.plan)}> Plan </label>
                </div>
                <Dropdown
                  placeholder="Select a plan"
                  value={initialsubscriptionType}
                  options={planOptions}
                  onChange={handlePlanUpdate}
                  className={styles.inputbox}
                  multiple={false}
                  selection
                />
              </Form.Field>
            </GridColumn>
          </GridRow>
          <div>
            <div className={styles.saveButton}>
              <SaveChanges
                onClick={handleSavePlanClick}
                disabled={disableSave}
              />
            </div>
          </div>
        </Grid.Column>
    </Container>
  );
};

export default SubscriptionPlan;
